export const moduleServices = [
    { id: 1,  text: 'Contingency',           value: ["contingency", "contingency-starter", "contingency-premium", "contingency-elite"] },
    { id: 2,  text: 'Deal Support',          value: ["deal-support", "deal-support-starter", "deal-support-premium", "deal-support-elite"] },
    { id: 3,  text: 'Employment Resources',  value: ["employment-resources-starter", "employment-resources-premium", "employment-resources-elite"] },
    { id: 12, text: 'Enterprise Consulting', value: ["enterprise-consulting"] },
    { id: 4,  text: 'Entity Maintenance',    value: ["entity-maintenance-program"] },
    { id: 5,  text: 'Entity Support',        value: ["entity", "entity²", "entity-support-starter", "entity-support-premium", "entity-support-elite"] },
    { id: 6,  text: 'Equity Sharing Plan',   value: ["equity", "equity-starter", "equity-premium", "equity-elite"] },
    { id: 11, text: 'HR Solutions',          value: ["hr-solutions-comp-design", "hr-solutions-employment-agreements", 
                                                     "hr-solutions-starter", "hr-solutions-comp-tsr", "hr-solutions-comp-premium", "hr-solutions-comp-elite"] },
    { id: 7,  text: 'Merger',                value: ["merger", "merger-premium", "merger-elite"] },
    { id: 10, text: 'Seller Advocacy',       value: ["seller-advocacy", "seller-advocacy-lite"] },
    { id: 8,  text: 'Succession Planning',   value: ["succession", "succession-premium", "succession-elite"] },
    { id: 9,  text: 'Valuation',             value: ["core-value", "practice-value", "enterprise-value", "valuation-starter", "valuation-premium", "valuation-elite"] },
]

export const serviceLevels = [
    { id: 1, text: 'Starter', value: 'starter' },
    { id: 2, text: 'Premium', value: 'premium' },
    { id: 3, text: 'Elite',   value: 'elite'   },
    { id: 4, text: 'Lite',    value: 'lite'    },
]

export const responsiblePartyItems = {
    'srg': 'SRG',
    'client': 'Client',
    'both': 'Both',
    'broker_dealer': 'Broker Dealer',
    'custodian': 'Custodian',
    'accountant': 'Accountant',
    'attorney': 'Attorney',
    'other': 'Other',
    'not_applicable': 'Not Applicable'
};

export const taskStatusItems = {
    'not_started': 'Not Started',
    'on_deck': 'On Deck',
    'scheduled': 'Scheduled',
    'in_progress': 'In Progress',
    'completed': 'Completed',
    'not_applicable': 'Not Applicable'
};

export const meetingStatusItems = {
    'scheduled': 'Scheduled',
    'completed': 'Completed',
    'cancelled': 'Canceled',
    'unscheduled': 'Unscheduled'
}

export const taskTypes = {
    meeting: 'Meeting',
    task: 'Task',
};

export const complexityItems = {
    low: 'Low',
    medium: 'Medium',
    high: 'High'
};

export const priorityItems = {
    normal: 'Normal',
    urgent: 'Urgent',
    backburner: 'Back Burner',
    annual: 'Annual'
};

export const durationItems = {
    "0.25": "00:15",
    "0.50": "00:30",
    "0.75": "00:45",
    "1.00": "01:00",
    "1.25": "01:15",
    "1.50": "01:30",
    "1.75": "01:45",
    "2.00": "02:00",
    "2.25": "02:15",
    "2.50": "02:30",
    "2.75": "02:45",
    "3.00": "03:00",
    "3.25": "03:15",
    "3.50": "03:30",
    "3.75": "03:45",
    "4.00": "04:00",
    "4.25": "04:15",
    "4.50": "04:30",
    "4.75": "04:45",
    "5.00": "05:00",
    "5.25": "05:15",
    "5.50": "05:30",
    "5.75": "05:45",
    "6.00": "06:00",
    "6.25": "06:15",
    "6.50": "06:30",
    "6.75": "06:45",
    "7.00": "07:00",
    "7.25": "07:15",
    "7.50": "07:30",
    "7.75": "07:45",
    "8.00": "08:00",
    "8.25": "08:15",
    "8.50": "08:30",
    "8.75": "08:45",
    "9.00": "09:00",
    "9.25": "09:15",
    "9.50": "09:30",
    "9.75": "09:45",
    "10.00": "10:00"
}

export const taskRoleItems = {
    pm: 'Project Manager',
    pc: 'Project Coordinator',
    pc2: 'Project Coordinator 2',
    ac: 'Admin Coordinator',
    lgl: 'Legal',
    plgl: 'Paralegal'
}

export const ownerItems = {
    'becb0705-1ab6-4bf1-8525-318d88b14dd4': 'Aliza Perry',
    '51709bec-7073-45cf-8d25-cc247b93df4a': 'Brenden Lapierre',
    '3c8e3f80-934a-4553-92a1-37a411ab4de2': 'David Grau Jr',
    '0eb8bacb-b83d-49f5-93ed-f3705a7e6316': 'Heidi Stone',
    'd95f21b2-98ff-4f40-a507-f4fabafd350c': 'Jaelyn Cooper',
    'ef765d03-0d40-421a-a909-fb1ea4b12815': 'Jessica Otero',
    'deb75a91-abf0-4b2a-b019-d3e4413a9381': 'John Roxburgh',
    '0884ad3e-0410-4fb5-8afb-b2e929f582fd': 'Jordon Segura',
    '0c2d7509-67e1-4e61-bd8d-cd07ecb49815': 'Juli Bigornia',
    '3f551c4b-3ec8-4f43-a4ee-3767e20ebee5': 'Julia Sexton',
    '7f185d7d-d877-4138-9dfd-6147cacd3620': 'Kristen Grau',
    '5800e940-6a07-40d8-ae70-8af0740bb3a9': 'Megan Danaher',
    '11a7ba20-d516-4e03-9448-e4803aaa96e1': 'Mikeala Devine',
    '718e7ebd-77b3-48f4-a34e-cba5de1f8bfd': 'Nicole Frey',
    'e9229c30-9b96-4833-bfbf-56c89bfea120': 'Parker Finot',
    '9596521f-123f-49da-b128-2e232ad67ae3': 'Ryan Grau',
    'ba29fe7e-c1ce-4e64-ab7a-295b1b3522b1': 'Sarah Farmer',
    'f6f85079-42ed-4027-836f-fc1c13290598': 'Vicki Aguilar',
    // '27a977e6-9280-4b48-a763-4aaf5a5ad542': 'Cliff Weiler' // REMOVE AFTER TESTING
};

// Keep inactive owners visible only when already assigned to an existing task.
export const inactiveTaskOwnerIds = [
    'be64ad88-66fb-43f5-b15d-db0572322bbc', // David Mueller
    '5ac4f56b-8bc1-4280-9d92-17cb46f89504', // Robin Tippie
    'd9038652-f151-4b08-b426-b64d12b70394', // Todd Fulks
    '1bcd541c-5202-41eb-a784-f65af3fedd6d', // Courtney Sobkow
    '18fcd197-332a-41ae-90f3-ec3ad71fe160', // Will Nabors
];

export const startTimeItems = {};

const options = { hour: 'numeric', minute: 'numeric' }; 
const timeFormatter = new Intl.DateTimeFormat('en-US', options);
const today = new Date();
const year = today.getFullYear();
const month = today.getMonth();
const day = today.getDate();

for (let hour = 10; hour <= 26; hour++) {
    for (let minute = 0; minute < 60; minute += 15) {
        const hour24 = hour.toString().padStart(2, '0');
        const minuteStr = minute.toString().padStart(2, '0');

        const thisDate = new Date(Date.UTC(year, month, day, hour24, minuteStr, 0));
        
        const displayTime = timeFormatter.format(thisDate);
        
        startTimeItems[`${hour24}:${minuteStr}`] = displayTime;
    }
}

export const usTimeZones = {
    "America/New_York": "Eastern",
    "America/Chicago": "Central",
    "America/Denver": "Mountain",
    "America/Los_Angeles": "Pacific"
};

export const srgConsultants = [ // srg_team
    {
        "name": "David Grau Jr.", 
        "email": "david.graujr@successionresourcegroup.com", 
        "image": "assets/experts/davidgraujr_circle150.png", 
        "phone": "(503) 446-1826", 
        "title": "President", 
        "user_id": "3c8e3f80-934a-4553-92a1-37a411ab4de2",
        "can_lead_meetings": true,
        "cal_link": "https://calendly.com/srg-enterprise-consulting/client-consultation-call-dg",
        "sub_team": []
    },
    {
        "name": "Ryan Grau", 
        "email": "ryan.grau@successionresourcegroup.com", 
        "image": "assets/experts/ryangrau_circle150.png", 
        "phone": "(503) 420-8843", 
        "title": "Director of Valuations", 
        "user_id": "9596521f-123f-49da-b128-2e232ad67ae3", 
        "can_lead_meetings": true,
        "cal_link": "https://calendly.com/srg-enterprise-consulting/client-consultation-call-rg",
        "sub_team": [    
            {
                "name": "John Roxburgh", 
                "email": "john.roxburgh@successionresourcegroup.com", 
                "image": "assets/experts/johnroxburgh_circle150.png", 
                "phone": "(503) 433-3475", 
                "title": "Project Coordinator", 
                "user_id": "deb75a91-abf0-4b2a-b019-d3e4413a9381", 
                "can_lead_meetings": false,
                "cal_link": "https://calendly.com/john-roxburgh/30min"
            }, 
            {
                "name": "Juli Bigornia", 
                "email": "juli.bigornia@successionresourcegroup.com", 
                "image": "assets/experts/julibigornia_circle150.png", 
                "phone": "", 
                "title": "Project Administrator", 
                "user_id": "0c2d7509-67e1-4e61-bd8d-cd07ecb49815", 
                "can_lead_meetings": false,
                "cal_link": "https://calendly.com/juli-bigornia/30min"
            }
        ]
    },
    {
        "name": "Julia Sexton", 
        "email": "julia.sexton@successionresourcegroup.com", 
        "image": "assets/experts/juliasexton_circle150.png", 
        "phone": "(503) 420-8843", 
        "title": "Project Manager", 
        "user_id": "3f551c4b-3ec8-4f43-a4ee-3767e20ebee5", 
        "can_lead_meetings": true,
        "cal_link": "https://calendly.com/srg-enterprise-consulting/client-consultation-call-js",
        "sub_team": [
            {
                "name": "Megan Danaher",
                "email": "megan.danaher@successionresourcegroup.com",
                "image": "assets/experts/megandanaher_circle150.png",
                "phone": "(971) 369-0084",
                "title": "Associate",
                "user_id": "5800e940-6a07-40d8-ae70-8af0740bb3a9",
                "can_lead_meetings": false,
                "cal_link": ""
            }
        ]
    },
    {
        "name": "Nicole Frey, CFP®", 
        "email": "nicole.frey@successionresourcegroup.com", 
        "image": "assets/experts/nicolefrey_circle150.png", 
        "phone": "", 
        "title": "Director of Team Solutions", 
        "user_id": "718e7ebd-77b3-48f4-a34e-cba5de1f8bfd", 
        "can_lead_meetings": true,
        "cal_link": "https://calendly.com/srg-enterprise-consulting/client-consultation-call-nf",
        "sub_team": [
            {
                "name": "Jessica Otero",
                "email": "jessica.otero@successionresourcegroup.com",
                "image": "assets/experts/jessicaotero_circle150.png",
                "phone": "",
                "title": "Senior Project Coordinator",
                "user_id": "ef765d03-0d40-421a-a909-fb1ea4b12815",
                "can_lead_meetings": false,
                "cal_link": ""
            },
            {
                "name": "Jaelyn Cooper",
                "email": "jaelyn.cooper@successionresourcegroup.com",
                "image": "assets/experts/jaelyncooper_circle150.png",
                "phone": "(503) 433-3029",
                "title": "Associate",
                "user_id": "d95f21b2-98ff-4f40-a507-f4fabafd350c",
                "can_lead_meetings": false,
                "cal_link": ""
            }
        ]
    },
    {
        "name": "Kristen Grau", 
        "email": "kristen.grau@successionresourcegroup.com", 
        "image": "assets/experts/kristengrau_circle150.png", 
        "phone": "(503) 830-2512", 
        "title": "Executive Vice President", 
        "user_id": "7f185d7d-d877-4138-9dfd-6147cacd3620", 
        "can_lead_meetings": true,
        "cal_link": "https://calendly.com/srg-enterprise-consulting/client-consultation-call-kg",
        "sub_team": [
            {
                "name": "Aliza Perry",
                "email": "aliza.perry@successionresourcegroup.com",
                "image": "assets/experts/alizaperry_circle150.png",
                "phone": "(503) 433-2840",
                "title": "Project Coordinator",
                "user_id": "becb0705-1ab6-4bf1-8525-318d88b14dd4",
                "can_lead_meetings": false,
                "cal_link": "https://calendly.com/aliza-perry/60min"
            },
            {
                "name": "Jordon Segura",
                "email": "jordon.segura@successionresourcegroup.com",
                "image": "assets/experts/jordonsegura_circle150.png",
                "phone": "(503) 446-4761",
                "title": "Project Coordinator",
                "user_id": "0884ad3e-0410-4fb5-8afb-b2e929f582fd",
                "can_lead_meetings": false,
                "cal_link": "https://calendly.com/jordonsegura/30min"
            }
        ]
    },
    {
        "name": "Parker Finot", 
        "email": "parker.finot@successionresourcegroup.com", 
        "image": "assets/experts/parkerfinot_circle150.png", 
        "phone": "", 
        "title": "Director of Acquisition & Succession Planning", 
        "user_id": "e9229c30-9b96-4833-bfbf-56c89bfea120", 
        "can_lead_meetings": true,
        "cal_link": "https://calendly.com/srg-enterprise-consulting/client-consultation-call-pf",
        "sub_team": [
            {
                "name": "Brenden Lapierre",
                "email": "brenden.lapierre@successionresourcegroup.com",
                "image": "assets/experts/brendenlapierre_circle150.png",
                "phone": "(503) 427-9910",
                "title": "Associate",
                "user_id": "51709bec-7073-45cf-8d25-cc247b93df4a",
                "can_lead_meetings": false,
                "cal_link": "https://calendly.com/brendenlapierre/30min"
            }   
        ]
    }
]

export const srgProjectCoordinators = [
   {
        "name": "Aliza Perry",
        "email": "aliza.perry@successionresourcegroup.com",
        "image": "assets/experts/alizaperry_circle150.png",
        "phone": "(503) 433-2840",
        "title": "Project Coordinator",
        "user_id": "becb0705-1ab6-4bf1-8525-318d88b14dd4",
        "can_lead_meetings": false,
        "cal_link": "https://calendly.com/aliza-perry/60min"
    },
    {
        "name": "Jordon Segura",
        "email": "jordon.segura@successionresourcegroup.com",
        "image": "assets/experts/jordonsegura_circle150.png",
        "phone": "(503) 446-4761",
        "title": "Project Coordinator",
        "user_id": "0884ad3e-0410-4fb5-8afb-b2e929f582fd",
        "can_lead_meetings": false,
        "cal_link": "https://calendly.com/jordonsegura/30min"
    },
    {
        "name": "John Roxburgh", 
        "email": "john.roxburgh@successionresourcegroup.com", 
        "image": "assets/experts/johnroxburgh_circle150.png", 
        "phone": "(503) 433-3475", 
        "title": "Project Coordinator", 
        "user_id": "deb75a91-abf0-4b2a-b019-d3e4413a9381", 
        "can_lead_meetings": false,
        "cal_link": "https://calendly.com/john-roxburgh/30min"
    }, 
    {
        "name": "Juli Bigornia", 
        "email": "juli.bigornia@successionresourcegroup.com", 
        "image": "assets/experts/julibigornia_circle150.png", 
        "phone": "", 
        "title": "Project Administrator", 
        "user_id": "0c2d7509-67e1-4e61-bd8d-cd07ecb49815", 
        "can_lead_meetings": false,
        "cal_link": "https://calendly.com/juli-bigornia/30min"
    },
    {
        "name": "Megan Danaher",
        "email": "megan.danaher@successionresourcegroup.com",
        "image": "assets/experts/megandanaher_circle150.png",
        "phone": "(971) 369-0084",
        "title": "Associate",
        "user_id": "5800e940-6a07-40d8-ae70-8af0740bb3a9",
        "can_lead_meetings": false,
        "cal_link": ""
    },
    {
        "name": "Jaelyn Cooper",
        "email": "jaelyn.cooper@successionresourcegroup.com",
        "image": "assets/experts/jaelyncooper_circle150.png",
        "phone": "(503) 433-3029",
        "title": "Associate",
        "user_id": "d95f21b2-98ff-4f40-a507-f4fabafd350c",
        "can_lead_meetings": false,
        "cal_link": ""
    },
    {
        "name": "Brenden Lapierre",
        "email": "brenden.lapierre@successionresourcegroup.com",
        "image": "assets/experts/brendenlapierre_circle150.png",
        "phone": "(503) 427-9910",
        "title": "Associate",
        "user_id": "51709bec-7073-45cf-8d25-cc247b93df4a",
        "can_lead_meetings": false,
        "cal_link": "https://calendly.com/brendenlapierre/30min"
    },
    {
        "name": "Jessica Otero",
        "email": "jessica.otero@successionresourcegroup.com",
        "image": "assets/experts/jessicaotero_circle150.png",
        "phone": "",
        "title": "Senior Project Coordinator",
        "user_id": "ef765d03-0d40-421a-a909-fb1ea4b12815",
        "can_lead_meetings": false,
        "cal_link": ""
    },
    {
        "name": "Kristen Grau", 
        "email": "kristen.grau@successionresourcegroup.com", 
        "image": "assets/experts/kristengrau_circle150.png", 
        "phone": "(503) 830-2512", 
        "title": "Executive Vice President", 
        "user_id": "7f185d7d-d877-4138-9dfd-6147cacd3620", 
        "can_lead_meetings": true,
        "cal_link": "https://calendly.com/srg-enterprise-consulting/client-consultation-call-kg"
    },
    {
        "name": "Julia Sexton", 
        "email": "julia.sexton@successionresourcegroup.com", 
        "image": "assets/experts/juliasexton_circle150.png", 
        "phone": "(503) 420-8843", 
        "title": "Project Manager", 
        "user_id": "3f551c4b-3ec8-4f43-a4ee-3767e20ebee5", 
        "can_lead_meetings": true,
        "cal_link": "https://calendly.com/srg-enterprise-consulting/client-consultation-call-js"
    },
    {
        "name": "Nicole Frey, CFP®", 
        "email": "nicole.frey@successionresourcegroup.com", 
        "image": "assets/experts/nicolefrey_circle150.png", 
        "phone": "", 
        "title": "Director of Team Solutions", 
        "user_id": "718e7ebd-77b3-48f4-a34e-cba5de1f8bfd", 
        "can_lead_meetings": true,
        "cal_link": "https://calendly.com/srg-enterprise-consulting/client-consultation-call-nf"
    },
    {
        "name": "Ryan Grau", 
        "email": "ryan.grau@successionresourcegroup.com", 
        "image": "assets/experts/ryangrau_circle150.png", 
        "phone": "(503) 420-8843", 
        "title": "Director of Valuations", 
        "user_id": "9596521f-123f-49da-b128-2e232ad67ae3", 
        "can_lead_meetings": true,
        "cal_link": "https://calendly.com/srg-enterprise-consulting/client-consultation-call-rg"
    },
    {
        "name": "Parker Finot", 
        "email": "parker.finot@successionresourcegroup.com", 
        "image": "assets/experts/parkerfinot_circle150.png", 
        "phone": "", 
        "title": "Director of Acquisition & Succession Planning", 
        "user_id": "e9229c30-9b96-4833-bfbf-56c89bfea120", 
        "can_lead_meetings": true,
        "cal_link": "https://calendly.com/srg-enterprise-consulting/client-consultation-call-pf"
    },
    {
        "name": "David Grau Jr.", 
        "email": "david.graujr@successionresourcegroup.com", 
        "image": "assets/experts/davidgraujr_circle150.png", 
        "phone": "(503) 446-1826", 
        "title": "President", 
        "user_id": "3c8e3f80-934a-4553-92a1-37a411ab4de2",
        "can_lead_meetings": true,
        "cal_link": "https://calendly.com/srg-enterprise-consulting/client-consultation-call-dg"
    }
]


export const srgProjectManagers = [
    {
        "name": "Kristen Grau", 
        "email": "kristen.grau@successionresourcegroup.com", 
        "image": "assets/experts/kristengrau_circle150.png", 
        "phone": "(503) 830-2512", 
        "title": "Executive Vice President", 
        "user_id": "7f185d7d-d877-4138-9dfd-6147cacd3620", 
        "can_lead_meetings": true,
        "cal_link": "https://calendly.com/srg-enterprise-consulting/client-consultation-call-kg",
        "sub_team": [
            {
                "name": "Aliza Perry",
                "email": "aliza.perry@successionresourcegroup.com",
                "image": "assets/experts/alizaperry_circle150.png",
                "phone": "(503) 433-2840",
                "title": "Project Coordinator",
                "user_id": "becb0705-1ab6-4bf1-8525-318d88b14dd4",
                "can_lead_meetings": false,
                "cal_link": "https://calendly.com/aliza-perry/60min"
            },
            {
                "name": "Jordon Segura",
                "email": "jordon.segura@successionresourcegroup.com",
                "image": "assets/experts/jordonsegura_circle150.png",
                "phone": "(503) 446-4761",
                "title": "Project Coordinator",
                "user_id": "0884ad3e-0410-4fb5-8afb-b2e929f582fd",
                "can_lead_meetings": false,
                "cal_link": "https://calendly.com/jordonsegura/30min"
            }
        ]
    },
    {
        "name": "Julia Sexton", 
        "email": "julia.sexton@successionresourcegroup.com", 
        "image": "assets/experts/juliasexton_circle150.png", 
        "phone": "(503) 420-8843", 
        "title": "Project Manager", 
        "user_id": "3f551c4b-3ec8-4f43-a4ee-3767e20ebee5", 
        "can_lead_meetings": true,
        "cal_link": "https://calendly.com/srg-enterprise-consulting/client-consultation-call-js",
        "sub_team": [
            {
                "name": "Megan Danaher",
                "email": "megan.danaher@successionresourcegroup.com",
                "image": "assets/experts/megandanaher_circle150.png",
                "phone": "(971) 369-0084",
                "title": "Associate",
                "user_id": "5800e940-6a07-40d8-ae70-8af0740bb3a9",
                "can_lead_meetings": false,
                "cal_link": ""
            }
        ]
    },
    {
        "name": "Nicole Frey, CFP®", 
        "email": "nicole.frey@successionresourcegroup.com", 
        "image": "assets/experts/nicolefrey_circle150.png", 
        "phone": "", 
        "title": "Director of Team Solutions", 
        "user_id": "718e7ebd-77b3-48f4-a34e-cba5de1f8bfd", 
        "can_lead_meetings": true,
        "cal_link": "https://calendly.com/srg-enterprise-consulting/client-consultation-call-nf",
        "sub_team": [
            {
                "name": "Jessica Otero",
                "email": "jessica.otero@successionresourcegroup.com",
                "image": "assets/experts/jessicaotero_circle150.png",
                "phone": "",
                "title": "Senior Project Coordinator",
                "user_id": "ef765d03-0d40-421a-a909-fb1ea4b12815",
                "can_lead_meetings": false,
                "cal_link": ""
            },
            {
                "name": "Jaelyn Cooper",
                "email": "jaelyn.cooper@successionresourcegroup.com",
                "image": "assets/experts/jaelyncooper_circle150.png",
                "phone": "(503) 433-3029",
                "title": "Associate",
                "user_id": "d95f21b2-98ff-4f40-a507-f4fabafd350c",
                "can_lead_meetings": false,
                "cal_link": ""
            }
        ]
    },
    {
        "name": "Ryan Grau", 
        "email": "ryan.grau@successionresourcegroup.com", 
        "image": "assets/experts/ryangrau_circle150.png", 
        "phone": "(503) 420-8843", 
        "title": "Director of Valuations", 
        "user_id": "9596521f-123f-49da-b128-2e232ad67ae3", 
        "can_lead_meetings": true,
        "cal_link": "https://calendly.com/srg-enterprise-consulting/client-consultation-call-rg",
        "sub_team": [    
            {
                "name": "John Roxburgh", 
                "email": "john.roxburgh@successionresourcegroup.com", 
                "image": "assets/experts/johnroxburgh_circle150.png", 
                "phone": "(503) 433-3475", 
                "title": "Project Coordinator", 
                "user_id": "deb75a91-abf0-4b2a-b019-d3e4413a9381", 
                "can_lead_meetings": false,
                "cal_link": "https://calendly.com/john-roxburgh/30min"
            }, 
            {
                "name": "Juli Bigornia", 
                "email": "juli.bigornia@successionresourcegroup.com", 
                "image": "assets/experts/julibigornia_circle150.png", 
                "phone": "", 
                "title": "Project Administrator", 
                "user_id": "0c2d7509-67e1-4e61-bd8d-cd07ecb49815", 
                "can_lead_meetings": false,
                "cal_link": "https://calendly.com/juli-bigornia/30min"
            }
        ]
    },
    {
        "name": "Parker Finot", 
        "email": "parker.finot@successionresourcegroup.com", 
        "image": "assets/experts/parkerfinot_circle150.png", 
        "phone": "", 
        "title": "Director of Acquisition & Succession Planning", 
        "user_id": "e9229c30-9b96-4833-bfbf-56c89bfea120", 
        "can_lead_meetings": true,
        "cal_link": "https://calendly.com/srg-enterprise-consulting/client-consultation-call-pf",
        "sub_team": [
            {
                "name": "Brenden Lapierre",
                "email": "brenden.lapierre@successionresourcegroup.com",
                "image": "assets/experts/brendenlapierre_circle150.png",
                "phone": "(503) 427-9910",
                "title": "Associate",
                "user_id": "51709bec-7073-45cf-8d25-cc247b93df4a",
                "can_lead_meetings": false,
                "cal_link": "https://calendly.com/brendenlapierre/30min"
            }   
        ]
    },
    {
        "name": "David Grau Jr.", 
        "email": "david.graujr@successionresourcegroup.com", 
        "image": "assets/experts/davidgraujr_circle150.png", 
        "phone": "(503) 446-1826", 
        "title": "President", 
        "user_id": "3c8e3f80-934a-4553-92a1-37a411ab4de2",
        "can_lead_meetings": true,
        "cal_link": "https://calendly.com/srg-enterprise-consulting/client-consultation-call-dg",
        "sub_team": []
    }
]


export const srgSalesReps = [
    {
        "name": "Nicole Sinclair", 
        "email": "nicole.sinclair@successionresourcegroup.com", 
        "image": "assets/experts/nicolesinclair_circle150.png", 
        "phone": "(503) 420-5462",
        "title": "Business Development Manager", 
        "user_id": "c181d57d-95c8-4f3c-999a-d92328f4b4c1", 
    },
    {
        "name": "Craig Chanti",
        "email": "craig.chanti@successionresourcegroup.com", 
        "image": "assets/experts/craigchanti_circle150.png",
        "phone": "(503) 433-5575",  
        "title": "Business Development Representative", 
        "user_id": "25251fcf-4b3b-4ee5-b366-3f09b296c648", 
    },
    {
        "name": "Sabrina Powell", 
        "email": "sabrina.powell@successionresourcegroup.com", 
        "image": "assets/experts/sabrinapowell_circle150.png", 
        "phone": "(503) 446-6486",
        "title": "Business Development Representative", 
        "user_id": "106c1dd1-3a10-49d2-a082-9538d69c05ee", 
    }
];


// WEBPACK FOOTER //
// ./src/helpers/constants.js